import { API } from './API';

const path = `digitacao`;

const DigitacaoService = {
    proxima: async regiao => await API.post(`${path}/proxima`, null, regiao ? { params: { regiao } } : undefined),
    proximaRevisao: async () => await API.post(`${path}/proxima-revisao`),
    regioes: async () => await API.get(`${path}/regioes`),
    reservas: async () => await API.post(`${path}/reservas`),
    reservasRevisao: async () => await API.post(`${path}/reservas-revisao`),
    registrar: async payload => await API.post(`${path}/registrar`, payload),
    invalidar: async payload => await API.post(`${path}/invalidar`, payload),
}

export default DigitacaoService;
